export const ADDRESS_LINE_MAX_LENGTH = 26;
export const CITY_MAX_LENGTH = 18;
export const ZIPCODE_LENGTH = 5;
export const EMAIL_MAX_LENGTH = 50;
export const INCOME_SOURCE_MAX_LENGTH = 200;

export const partialSuccessErrorMessage = (sectionName: string) =>
  `Unsuccessful in updating the Cardmember's ${sectionName} information at FDR. Please try again. If the problem continues, please contact the Help Desk for assistance.`;

export const MIN_START_AND_END_DATE_FOR_HISTORY = "2015-01-01";

export const ADDRESS_WARNING =
  "A_0043 Warning: Auth flag set for Return mail. Please update address. You may continue processing with this message.";
